import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {

  constructor() { }

  rightOverLay_small = "25.8%";
  rightOverlay_large = "50%";
  rightOverlay_ex_large = "70%";
  footerComponentId = "270";
  publicationid = "11183";
  LoginComponentId = "371";
}
